/**
 * @file 契約情報取得フック（軽量版）
 *
 * SigV4認証付きGETリクエストで契約情報を取得し、AxiosResponseをそのまま返却する。
 * Recoilへの格納やエラーハンドリングは呼び出し元に委譲する点がuseCallAPIGetContractInfoとの違い。
 */
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ContractInfoResponse } from '@/types/api/mypage/contractInfo';

/** 対象APIのエンドポイント */
const url = ApiUrl.Read.CONTRACT_INFO;

/**
 * 契約情報を取得する軽量フック（AxiosResponseをそのまま返却）
 * @returns execute - SigV4認証付きGETリクエストを実行し、レスポンスを返却
 */
const useGetContractInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<ContractInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetContractInfo;
